import React from 'react';

import { useTheme } from 'styled-components';

import { MdRadioButtonChecked, MdRadioButtonUnchecked } from 'react-icons/md';

import { Container } from './styles';

import { CheckboxProps } from './interface';

const Checkbox: React.FC<CheckboxProps> = ({ onClick, label, status }) => {
  const { colors } = useTheme();

  return (
    <Container status={status} onClick={onClick}>
      {status ? (
        <MdRadioButtonChecked size={32} color={colors.IC1} />
      ) : (
        <MdRadioButtonUnchecked size={32} color={colors.IC1} />
      )}

      <span>{label}</span>
    </Container>
  );
};

export default Checkbox;
